import { Icon } from "@chakra-ui/icons"
import React from "react"

const FacebookBoldIcon = props => {
  return (
    <Icon viewBox="0 0 15.73 15.73" {...props}>
      <g>
        <path
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          d="M.5.5h14.73v14.73H.5z"
        />
        <path
          d="M9.47 6.82h-1v-.68c.07-.63 1.13-.51 1.13-.51v-1S7.49 4 7.08 5.6A7.41 7.41 0 007 6.82h-.86V8h.93v3.26h1.36V8h1l.12-1.2h-.08"
          fill="currentColor"
        />
      </g>
    </Icon>
  )
}

export default FacebookBoldIcon
